import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomePageService {

  constructor(public http: HttpClient) { }

  getIndicadoresDashboard() {
    return this.http.get(`${environment.apiUrl}/DashboardHome/GetIndicadoresComunidad`)
  }

  getConexionesComunidad() {
    return this.http.get(`${environment.apiUrl}/DashboardHome/GetConexionesComunidad`)
  }
  getTieneComunidad() {
    return this.http.get(`${environment.apiUrl}/DashboardHome/GetTieneComunidad`)
  }
  EnviarSolicitudContcto(parametros:any) {
    return this.http.post(`${environment.apiUrl}/SolicitudContacto/EnviarMensajeDeSolicitudContactoInnovacion`,parametros)
  }
}
